module.exports = __webpack_public_path__ + "img/Butterfly_00128.2dafa4b5.png";